import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PP() {
  const { t } = useTranslation();

  return (
      <section className="max-w-[1280px] w-full mx-auto mt-[58px] py-[50px]">
        <main>
          <h1 className="font-bold text-MainTextColor text-5xl mb-14">
            {t('privacyPolicyTitle')}
          </h1>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article1Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article1Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article2Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article2Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article3Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article3Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article4Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article4Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article5Title')}
          </h2>
          <ul className="list-disc font-medium text-[#515151] text-lg mb-6 pl-7">
            <li className="my-3">{t('article5Item1')}</li>
            <li className="my-3">{t('article5Item2')}</li>
            <li className="my-3">{t('article5Item3')}</li>
          </ul>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article6Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article6Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article7Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article7Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article8Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article8Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article9Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article9Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article10Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article10Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article11Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article11Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article12Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article12Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article13Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article13Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article14Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article14Content')}
          </p>
          <h2 className="font-bold text-MainTextColor text-3xl mb-8">
            {t('article15Title')}
          </h2>
          <p className="font-medium text-[#515151] text-lg mb-6 pl-7">
            {t('article15Content')}
          </p>
        </main>
      </section>
  );
}
